import * as React from "react";
import { cn } from "@/lib/utils";

interface BannerProps extends React.HTMLAttributes<HTMLDivElement> {
    children: React.ReactNode;
}

const Banner = React.forwardRef<HTMLDivElement, BannerProps>(
    ({ className, children, ...props }, ref) => {
        return (
            <div
                ref={ref}
                className={cn(
                    "fixed top-0 left-0 right-0 z-50 h-12 bg-primary text-primary-foreground border-b border-primary/20",
                    className
                )}
                {...props}
            >
                <div className="flex h-full items-center justify-center px-4">
                    {children}
                </div>
            </div>
        );
    }
);
Banner.displayName = "Banner";

export { Banner };
